import { Spacer } from '@zillow/constellation';
import { Paragraph, Text } from '@zillow/constellation-10';

type Props = {
  outcomeStats: number;
  source: string;
};

const WizardTipContent = ({ outcomeStats, source }: Props) => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        Providing renters with the rental’s square footage can result in up to {outcomeStats}% more contacts, based on
        data for similarly priced listings.
      </Paragraph>

      <Spacer marginY="sm">
        <Text textStyle="body-xs" color="text.subtle">
          {source}
        </Text>
      </Spacer>
    </div>
  );
};

export default WizardTipContent;
